import { OrderChannel } from './order_channel.js';

export function name(channel: OrderChannel): string {
  switch (channel) {
    case OrderChannel.Catering:
      return 'Catering';
    case OrderChannel.DriveThru:
      return 'Drive-Thru';
    case OrderChannel.Flash:
      return 'Contactless';
    case OrderChannel.Kiosk:
      return 'Kiosk';
    case OrderChannel.Linebuster:
      return 'Linebuster';
    case OrderChannel.Web:
      return 'Web';
  }
}

// TODO: remove once we break up kiosk and flash
export function nameCombiningKioskAndFlash(channel: OrderChannel): string {
  switch (channel) {
    case OrderChannel.Kiosk:
      return 'Kiosk/Flash';
    case OrderChannel.Catering:
    case OrderChannel.DriveThru:
    case OrderChannel.Flash:
    case OrderChannel.Linebuster:
    case OrderChannel.Web:
      return name(channel);
  }
}

export function isOrderAhead(channel: OrderChannel): boolean {
  switch (channel) {
    case OrderChannel.Catering:
    case OrderChannel.Web:
      return true;
    case OrderChannel.DriveThru:
    case OrderChannel.Flash:
    case OrderChannel.Kiosk:
    case OrderChannel.Linebuster:
      return false;
  }
}

export function isKiosk(channel: OrderChannel): boolean {
  switch (channel) {
    case OrderChannel.DriveThru:
    case OrderChannel.Linebuster:
    case OrderChannel.Kiosk:
      return true;
    case OrderChannel.Catering:
    case OrderChannel.Web:
    case OrderChannel.Flash:
      return false;
  }
}

export function isFlash(channel: OrderChannel): boolean {
  switch (channel) {
    case OrderChannel.Catering:
    case OrderChannel.Kiosk: // @todo: remove once we break up kiosk and flash
    case OrderChannel.Flash:
    case OrderChannel.Web:
      return true;
    case OrderChannel.DriveThru:
    case OrderChannel.Linebuster:
      return false;
  }
}
